import React from 'react';
import { Link, useHistory, useParams } from 'react-router-dom';
import { Breadcrumb } from 'components';
import { Tabs, Tab } from '@material-ui/core';
import { TabContext, TabPanel } from '@material-ui/lab';
import DataMappingTable from './Mapped/DataMappingTable';
import UnmappedDataTable from './Unmapped/UnmappedDataTable';
import useStyles from './styles';


const DataMappingPage = () => {
  const classes = useStyles();
  const history = useHistory();
  const {selectedTab = 'mapped'} = useParams<{selectedTab?: string}>();

  return (
    <div className="flex-grow h-full scroll-y pb-25">
      <div className="mb-sm-30">
        <Breadcrumb
          routeSegments={[
            { name: 'Data Mapping' }
          ]}
        />
      </div>
      <div className="mx-10">
        <TabContext value={selectedTab}>
          <Tabs
            value={selectedTab}
            onChange={(_, newValue) => history.push(newValue)}
            className={classes.rootTabs}
          >
            <Tab
              className={classes.tabsTitles}
              label="Data Mapping"
              value="mapped"
              component={Link}
              to="/data-mapping/mapped"
            />
            <Tab
              className={classes.tabsTitles}
              label="Unmapped Data"
              value="unmapped"
              component={Link}
              to="/data-mapping/unmapped"
            />
          </Tabs>
          <TabPanel className="p-0" value="mapped">
            <DataMappingTable />
          </TabPanel>
          <TabPanel className="p-0" value="unmapped">
            <UnmappedDataTable />
          </TabPanel>
        </TabContext>
      </div>
    </div>
  );
};

export default DataMappingPage;
